import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { FILTER_TYPES } from "../Constants";

var Filter =
/*#__PURE__*/
function () {
  function Filter(context) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FILTER_TYPES[0];
    var cutoff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
    var resonance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.1;

    _classCallCheck(this, Filter);

    this.context = context;
    this.destination = this.context.createBiquadFilter();
    this.type = type;
    this.cutoff = cutoff;
    this.resonance = 0.5;
    this.envelopeAmount = 1;
    this.envelope = {
      a: 0,
      d: 0.5,
      s: this.cutoff,
      r: 0.5
    };
  }

  _createClass(Filter, [{
    key: "on",
    value: function on(MidiEvent) {
      this.start(this.context.currentTime, MidiEvent.frequency);
    }
  }, {
    key: "off",
    value: function off() {
      return this.stop(this.context.currentTime);
    }
  }, {
    key: "start",
    value: function start(time) {
      return this.destination.frequency.setTargetAtTime(this.sustain, time + this.attack, this.decay + 0.001);
    }
  }, {
    key: "stop",
    value: function stop(time) {
      return this.destination.frequency.setTargetAtTime(this.cutoff, time, this.release);
    }
  }, {
    key: "connect",
    value: function connect(destination) {
      this.destination.connect(destination);
    }
  }, {
    key: "type",
    set: function set(value) {
      this.destination.type = value;
    },
    get: function get() {
      return this.destination.type;
    }
  }, {
    key: "cutoff",
    set: function set(value) {
      this.destination.frequency.value = value;
    },
    get: function get() {
      return this.destination.frequency.value;
    }
  }, {
    key: "Q",
    set: function set(value) {
      this.destination.Q.value = value;
    },
    get: function get() {
      return this.destination.Q.value;
    }
  }, {
    key: "attack",
    set: function set(value) {
      this.envelope.a = value;
    },
    get: function get() {
      return this.envelope.a;
    }
  }, {
    key: "decay",
    set: function set(value) {
      this.envelope.d = value;
    },
    get: function get() {
      return this.envelope.d;
    }
  }, {
    key: "sustain",
    set: function set(value) {
      this.cutoff = value;
    },
    get: function get() {
      return this.cutoff;
    }
  }, {
    key: "release",
    set: function set(value) {
      this.envelope.r = value;
    },
    get: function get() {
      return this.envelope.r;
    }
  }]);

  return Filter;
}();

export { Filter as default };